import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { requestClientesById } from "../../actions/cliente";
import { Grid } from "@material-ui/core";
import colores from "../../shared/constants/styles";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import Tienda from "./tienda";
import { makeStyles } from "@material-ui/core";
import { useParams } from "react-router-dom";
import ContactoCard from "./contactoCard";
import { Alert, Stack } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  PDato: {
    fontSize: 18,
    fontWeight: "bold",
  },
  PDatoCliente: {
    fontSize: 18,
    fontWeight: "bold",
    color: "gray",
  },
  OficialBack: {
    backgroundColor: "pink",
  },
}));

const ClienteVendedor = (props) => {
  const style = useStyles();
  let { id } = useParams();

  const [successEnviado, setSuccessEnviado] = useState(false);
  const [errorEnviado, setErrorEnviado] = useState(false);

  useEffect(() => {
    props.requestClientesById(id);
  }, []);

  return (
    <>
      <div
        style={{
          backgroundColor: colores.grisClaro,
          overflow: "hidden",
          clear: "both",
        }}
      >
        <div className="d-flex justify-content-center">
          <hr style={{ width: "90%", color: "black" }}></hr>
        </div>
        <div
          className="d-flex justify-content-between flex-wrap align-items-center"
          style={{
            marginBottom: "0.600rem",
            paddingRight: "3rem",
            paddingLeft: "21px",
          }}
        >
          <h1 className="fw-bolder" style={{ margin: "1rem 3.5rem" }}>
            PERFIL
          </h1>
        </div>
      </div>
      <div className="container">
        <div style={{ marginTop: "5rem" }}>
          <div className="d-flex align-content-center flex-wrap"></div>
          <p
            style={{
              fontWeight: "bold",
              fontSize: "2.1875rem",
              marginBottom: "4rem",
            }}
          >
            Perfil de cliente: {props.cliente?.nombre}
          </p>

          <div className="row">
            <div className="col-sm-2" style={{ margin: "4vh" }}>
              <div
                style={{
                  borderRadius: "50%",
                  width: "5vw",
                  height: "5vw",
                  backgroundColor: colores.azulOscuro,
                }}
              >
                <PersonOutlineOutlinedIcon
                  style={{
                    fill: "white",
                    width: "3vw",
                    height: "3vw",
                    margin: "1vw",
                  }}
                />
              </div>
            </div>
            <div
              class="col-sm-1"
              style={{
                borderLeft: "2px solid",
                borderLeftColor: colores.azulOscuro,
                height: "200px",
              }}
            ></div>

            <div className="col-sm-4">
              <p className={style.PDatoCliente}>N° do usuário: </p>
              <p className={style.PDato}>{id}</p>
            </div>
            <div className="col-sm-4">
              <p className={style.PDatoCliente}>Razão Social: </p>
              <p className={style.PDato}>{props.cliente?.nombre}</p>
              <p className={style.PDatoCliente}>CNPJ: </p>
              <p className={style.PDato}>{props.cliente?.numero}</p>
            </div>
          </div>
          <div className="container">
            <p style={{ fontSize: "2.1875rem", fontWeight: "bold" }}>
              Contactos
            </p>
            <div className="d-flex flex-wrap">
              <Grid container spacing={3} className="d-flex">
                {props.cliente.contactos?.$values.length >= 0 &&
                  props.cliente.contactos?.$values?.map((contacto) => (
                    <ContactoCard
                      clienteId={id}
                      id={contacto.contactoId}
                      nroDocumento={props.cliente.numero}
                      nombre={contacto.nombre}
                      email={contacto.email}
                      contactoNro={contacto.contactoNro}
                      createDate={contacto.createDate}
                      enviadoEmail={contacto.enviadoEmail}
                      primerInicio={contacto.primerInicio}
                      setSuccessEnviado={setSuccessEnviado}
                      setErrorEnviado={setErrorEnviado}
                    />
                  ))}
              </Grid>
              {successEnviado && (
                <Stack sx={{ width: "70%" }} spacing={2}>
                  <Alert severity="success">Email enviado correctamente</Alert>
                </Stack>
              )}
              {errorEnviado && (
                <Stack sx={{ width: "70%" }} spacing={2}>
                  <Alert severity="error">Error al enviar el E-mail</Alert>
                </Stack>
              )}
            </div>
          </div>
          <div className="container">
            <p style={{ fontSize: "2.1875rem", fontWeight: "bold" }}>Lojas</p>
            <div className="d-flex flex-wrap">
              <Grid container spacing={5} className="d-flex">
                {props.cliente.tiendas?.$values.map((tienda) => (
                  <Tienda data={tienda} />
                ))}
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(
  (state) => ({
    cliente: state.clientes.cliente,
    loading: state.clientes.loading,
  }),
  (dispatch) => ({
    requestClientesById: (id) => dispatch(requestClientesById(id)),
  }),
)(ClienteVendedor);
